import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import { noop } from 'ui-components/default-props/noop';

import { useLocale } from '../../intl/hooks';
import { getLink } from '../../services/link-service';
import Global from '../../store/global-selectors';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type React from 'react';

type HelpArticleLinkProps = {
  articleId: string;
  children: React.ReactNode;
  ariaLabel?: string;
  className?: string;
  icon?: IconProp | null;
  anchor?: string;
  onClick?: () => void;
  url?: string;
  version?: string;
};

export const HelpArticleLink = ({
  articleId,
  ariaLabel,
  children,
  className = '',
  icon = null,
  anchor = '',
  onClick = noop,
  url,
  version,
}: HelpArticleLinkProps) => {
  const supportCountry = useSelector((state) => Global.selectSellerSupportCountry(state));
  const intl = useLocale();

  return (
    <a
      aria-label={ariaLabel}
      className={className}
      href={`${url ?? getLink(articleId, supportCountry, intl.locale, version)}${anchor}`}
      onClick={onClick}
      rel='noreferrer'
      target='_blank'
    >
      {children}
      {icon ? <FontAwesomeIcon icon={icon} /> : null}
    </a>
  );
};
